import { Pipe, PipeTransform } from '@angular/core';

declare const Mangler: any;

@Pipe({
	name: 'manglerFilter'
})
export class ManglerFilterPipe implements PipeTransform {

	transform(array: any[], testCondition: any = null): any {
		return array.filter(item => Mangler.test(item, testCondition));
	}

}
